import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { FundraisersTableProps } from '../FundraisersTable/FundraisersTable.types'

import { FundraiserVisibility } from '@percent/partner-dashboard/services/fundraisers/fundraisersService.types'
import { LocaleKey } from '@percent/partner-dashboard/i18n/config'

type VisibilityOption = {
  label: string
  value: FundraiserVisibility
  text: LocaleKey
}

const fundraiserVisibilityOptions: VisibilityOption[] = [
  {
    label: 'Listed',
    value: FundraiserVisibility.LISTED,
    text: 'status.visibility.listed'
  },
  {
    label: 'Unlisted',
    value: FundraiserVisibility.UNLISTED,
    text: 'status.visibility.unlisted'
  },
  {
    label: 'Public',
    value: FundraiserVisibility.PUBLIC,
    text: 'status.visibility.public'
  }
]

export const useVisibilityFilter = ({
  queryParams,
  setQueryParams
}: Pick<FundraisersTableProps, 'queryParams' | 'setQueryParams'>) => {
  const { t } = useTranslation()

  const onVisibilityChange = useCallback(
    (selectedLabels: string[]) => {
      const selectedValues = selectedLabels
        .map(label => {
          const option = fundraiserVisibilityOptions.find(opt => opt.label === label)

          return option?.value
        })
        .filter(Boolean) as FundraiserVisibility[]

      setQueryParams({
        visibility: selectedValues.length ? selectedValues : undefined
      })
    },
    [setQueryParams]
  )

  const getSelectedLabels = (selectedValues: FundraiserVisibility[] | undefined) => {
    if (!selectedValues) return []

    return fundraiserVisibilityOptions
      .filter(option => selectedValues.includes(option.value))
      .map(option => option.label)
  }

  return {
    visibilityOptions: fundraiserVisibilityOptions.map(opt => ({
      label: t(opt.text),
      value: opt.label
    })),
    onVisibilityChange,
    selectedVisibility: getSelectedLabels(queryParams?.visibility as FundraiserVisibility[] | undefined)
  }
}
